import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import classNames from 'classnames'
import { memo, useEffect, useMemo, useRef, useState } from 'react'

import { useStarAnimContext } from '../../providers/StarAnimProvider'

import styles from './StarAnim.module.scss'

type Props = {
  width?: number
  height?: number
  className?: string
}

export const StarAnim = memo(function StarAnim({
  width,
  height,
  className,
}: Props) {
  const starAnim = useStarAnimContext()
  const [isVisible, setIsVisible] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting)
      },
      { rootMargin: '100%' },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  const data = useMemo(() => {
    if (!starAnim) return undefined
    if (starAnim instanceof ArrayBuffer) return starAnim.slice(0)
    return starAnim
  }, [starAnim])

  return (
    <div
      ref={ref}
      style={{ width, height }}
      className={classNames(styles.starAnim, className)}
    >
      {isVisible && data && (
        <DotLottieReact data={data} autoplay loop width={width} height={height} />
      )}
    </div>
  )
})
